import React, { Suspense, lazy } from 'react';
import { Route } from 'react-router-dom';
import { VarosRoutes } from './infra';
import { WithRouterForApp } from './wrappers/WithRouter';
import { AppLoadingFallback } from './AppLoadingFallback';

// Lazy load the interview app - this creates a separate chunk
const LazyInterviewApp = lazy(
    () => import('./v2/entrypoint/interview/InterviewApp')
);

// Lazy load the main app - this creates a separate chunk
const LazyMainApp = lazy(() => import('./MainApp'));

function App() {
    return (
        <WithRouterForApp>
            <VarosRoutes>
                <Route
                    path="interview/*"
                    element={
                        <Suspense fallback={<AppLoadingFallback />}>
                            <LazyInterviewApp />
                        </Suspense>
                    }
                />
                <Route
                    path="*"
                    element={
                        <Suspense fallback={<AppLoadingFallback />}>
                            <LazyMainApp />
                        </Suspense>
                    }
                />
            </VarosRoutes>
        </WithRouterForApp>
    );
}

export default App;
